import React, {useEffect, useState} from 'react';
import Header from "../../components/navigation/Header";
import {getPurchaseStatus} from "../../services/ProductRepository";
import {Link, useParams} from "react-router-dom";
import {useError} from "../../hooks/useError";
import {FaCheckCircle} from "react-icons/fa";
import {VscError} from "react-icons/vsc";
import {routes} from "../../utils/Routes";

export function PurchaseConfirmation() {

    const [status, setStatus] = useState("PENDING");
    const [details, setDetails] = useState(null);
    const params = useParams();
    const {setErrorMessage} = useError();


    useEffect(() => {
        const fetchWithRetry = async () => {
            let attempts = 0;
            while (attempts < 3) {
                try {
                    const response = await getPurchaseStatus(params.id, setErrorMessage);
                    if(response.hasOwnProperty("status") && response.status !== "PENDING") {
                        setStatus(response.status)
                        setDetails(response);
                        return;
                    }

                    // If the status code requires retry, wait and try again
                    attempts++;
                    await new Promise(res => setTimeout(res, 1000 * attempts));
                } catch (err) {
                    setErrorMessage(err);
                    return;
                }
            }

            setErrorMessage(new Error('Max retries reached with status '));
        };


        fetchWithRetry();
    }, []);

    return (
        <div>
            <Header/>
            <div className={"container d-flex align-items-center justify-content-center align-content-center"}>

                {
                    status === "PENDING" || details == null ?
                        <>
                            <h3>Venter på transaksjon...</h3>
                            <div className="spinner-border" style={{width:"3rem", height:"3rem"}} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </>
                        :
                        <div className={"pt-5 text-center d-flex flex-column align-items-center justify-content-center align-content-center"} style={{minHeight:"80vh"}}>
                            {
                                details.success ? <FaCheckCircle size={64} className={"text-success mb-3"}/> : <VscError size={64} className={"text-danger mb-3"}/>
                            }

                            <h5>{details.subscriptionName}</h5>
                            <p>{details.price / 100} NOK / måned</p>
                            <p>{details.description}</p>

                            {
                                details.success ?
                                    <Link to={routes.productHomeAbs(details.productName)}
                                       className={"text-decoration-none btn btn-success text-white"}
                                        data-testid={"kurs-link"}
                                    >
                                        Gå til kurs
                                    </Link>
                                    :
                                    <Link to={details.link}
                                       className={"text-decoration-none btn btn-danger text-white"}>
                                        Tilbake
                                    </Link>
                            }

                        </div>
                }

            </div>
        </div>
    );
}